import React from 'react';
import { ServiceLocationsSectionProps } from '../../../../../Sections/Services/LocationsSection/LocationsSection';
import markerIcon from '../../../../../../assets/icons/point-yelow.svg';
import primaryMarkerIcon from '../../../../../../assets/icons/point-dark-blue.svg';
import MapWrapper from '../../../../../Common/MapWrapper';
import * as classes from './LocationSection.module.scss';
import cn from 'classnames';
import RoundedAppointmentTypesList from '../../../Components/RoundedAppointmentTypesList/RoundedAppointmentTypesList';
import mapDecorator from '../../../../../../assets/images/map-decorator.svg';
import { RADIUS_COLOR_MODERN_TEMPLATE } from '../../../../../../constants/constants';
import CircleBg from '../../../Components/CircleBG/CircleBG';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const LocationSection = ({
  primaryLocation,
  otherLocations,
  mobilityRadius,
  serviceName,
  appointmentTypes,
  serviceId,
  phoneNumber,
}: ServiceLocationsSectionProps) => {
  const { t } = useTranslation();
  return (
    <div data-aos='fade-in'>
      <CircleBg />
      <section className={classes.wrapper}>
        <div className={'row'}>
          <div className={cn('col-md-6 order-1 order-md-0', classes.mapWrapper)}>
            <MapWrapper
              phoneNumber={phoneNumber}
              serviceId={serviceId}
              mobilityRadius={mobilityRadius}
              otherLocations={otherLocations}
              primaryLocation={primaryLocation}
              otherLocationsMarkerIcon={markerIcon}
              primaryLocationMarkerIcon={primaryMarkerIcon}
              radiusColor={RADIUS_COLOR_MODERN_TEMPLATE}
            />
            <img src={mapDecorator} alt='' className={classes.mapDecorator} />
          </div>
          <div className={cn('col-md-6 order-0 order-md-1 col-lg-5 offset-lg-1', classes.infoWrapper)}>
            <div className={classes.title}>
              {serviceName} {t('services.locationsSection.sectionTitle')}
            </div>
            <div className={classes.appointmentTypesWrapper}>
              <RoundedAppointmentTypesList items={appointmentTypes} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LocationSection;
